export default __webpack_public_path__ + "static/media/cern-medium.8a697d2f.ttf";